import {MailOutlined, WhatsAppOutlined} from "@ant-design/icons";

const TelegramIcon = ({size = 22}) => (
    <svg viewBox={"0 0 24 24"} width={size} height={size} fill={"#229ED9"}>
        <path d={"M9.04 15.47 8.7 20.2c.5 0 .72-.21.98-.47l2.34-2.23 4.85 3.55c.89.5 1.53.24 1.77-.82l3.2-15c.29-1.32-.48-1.84-1.34-1.52L1.6 9.9c-1.3.5-1.28 1.22-.22 1.55l4.9 1.53 11.36-7.16c.53-.35 1.02-.16.62.2z"} />
    </svg>
);

// the fido passkey mark
const PasskeyIcon = ({size = 24}) => (
    <svg viewBox={"0 0 24 24"} width={size} height={size} fill={"currentColor"}>
        <circle cx={"9.2"} cy={"6.8"} r={"4.3"} />
        <path d={"M13.9 15.33a6.13 6.13 0 0 0-.37 5.27H1.4v-1.2c0-3.16 3.5-5.72 7.8-5.72 1.72 0 3.32.41 4.7 1.65z"} />
        <path
            fillRule={"evenodd"}
            d={"M17.8 9.6a3.7 3.7 0 0 1 1.4 7.12v2.68l1.1 1.1-2.5 2.5-1.4-1.4v-4.88a3.7 3.7 0 0 1 1.4-7.12zm0 2.1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z"}
        />
    </svg>
);

// a face in a capture frame: distinct at a glance from the passkey mark, and carries no
// vendor branding, which stays on the crm side
const FaceIcon = ({size = 24}) => (
    <svg viewBox={"0 0 24 24"} width={size} height={size} fill={"none"} stroke={"currentColor"} strokeWidth={"1.8"} strokeLinecap={"round"} strokeLinejoin={"round"}>
        <path d={"M3 8V5.5A2.5 2.5 0 0 1 5.5 3H8"} />
        <path d={"M16 3h2.5A2.5 2.5 0 0 1 21 5.5V8"} />
        <path d={"M21 16v2.5a2.5 2.5 0 0 1-2.5 2.5H16"} />
        <path d={"M8 21H5.5A2.5 2.5 0 0 1 3 18.5V16"} />
        <circle cx={"9.3"} cy={"10.5"} r={".9"} fill={"currentColor"} stroke={"none"} />
        <circle cx={"14.7"} cy={"10.5"} r={".9"} fill={"currentColor"} stroke={"none"} />
        <path d={"M9 14.8a3.6 3.6 0 0 0 6 0"} />
    </svg>
);

// a phone showing a row of code digits, so it reads as "code from an app" rather than a sms
const AuthenticatorIcon = ({size = 24}) => (
    <svg viewBox={"0 0 24 24"} width={size} height={size} fill={"none"} stroke={"currentColor"} strokeWidth={"1.8"} strokeLinecap={"round"} strokeLinejoin={"round"}>
        <rect x={"5.5"} y={"2.5"} width={"13"} height={"19"} rx={"2.5"} />
        <path d={"M10.5 18.5h3"} />
        <circle cx={"9"} cy={"11"} r={"1"} fill={"currentColor"} stroke={"none"} />
        <circle cx={"12"} cy={"11"} r={"1"} fill={"currentColor"} stroke={"none"} />
        <circle cx={"15"} cy={"11"} r={"1"} fill={"currentColor"} stroke={"none"} />
    </svg>
);

const brandMark = {color: "var(--primary-btn-bg-color)", display: "flex"};

// the dialog wants them at their own size, a row of provider icons at its own, so the size
// is asked for rather than baked in
export const methodIcon = (method, size) => {
    switch (method) {
        case "email":
            return <MailOutlined style={{fontSize: size || 22, color: "#d93025"}} />;
        case "telegram":
            return <TelegramIcon size={size || 22} />;
        case "whatsapp":
            return <WhatsAppOutlined style={{fontSize: size || 22, color: "#25D366"}} />;
        case "passkey":
            return (
                <span style={brandMark}>
                    <PasskeyIcon size={size || 24} />
                </span>
            );
        case "liveness":
            return (
                <span style={brandMark}>
                    <FaceIcon size={size || 24} />
                </span>
            );
        case "totp":
            return (
                <span style={brandMark}>
                    <AuthenticatorIcon size={size || 24} />
                </span>
            );
        default:
            return null;
    }
};

// keyed by the method names the server returns, so a missing entry means a missing method
const METHOD_ICONS = {
    email: <MailOutlined style={{fontSize: 22, color: "#d93025"}} />,
    telegram: <TelegramIcon />,
    whatsapp: <WhatsAppOutlined style={{fontSize: 22, color: "#25D366"}} />,
    passkey: (
        <span style={{color: "var(--primary-btn-bg-color)", display: "flex"}}>
            <PasskeyIcon />
        </span>
    ),
    liveness: (
        <span style={{color: "var(--primary-btn-bg-color)", display: "flex"}}>
            <FaceIcon />
        </span>
    ),
    totp: (
        <span style={{color: "var(--primary-btn-bg-color)", display: "flex"}}>
            <AuthenticatorIcon />
        </span>
    ),
};

export default METHOD_ICONS;
